import request, { getAxiosRequestConfig, newRequest } from 'utils/request'
import { Methods } from 'types/request'
import { EanLookupResponseBody, TownResponse } from './types'
import { LanguageLowercase } from 'store/app/types'
import { Address } from '@boltenergy-be/shared'

/**
 * Fetches the EAN numbers based on the given language & address
 *
 * @param {LanguageLowercase} language
 * @param {AddressWithTownCode} address
 * @returns {Promise<EanLookupResponseBody>}
 */
export const eanLookup = async (language: LanguageLowercase, address: Address): Promise<EanLookupResponseBody> => {
  const { success, data } = await newRequest<EanLookupResponseBody>(
    getAxiosRequestConfig(Methods.POST, '/market-message/preswitch/ean-lookup', { address, language })
  )

  return success && data ? data : { electricity: null, gas: null }
}

/**
 * Fetch the town from the API based on the given postal code
 *
 * @param postalCode
 * @return Promise<TownResponse|null>
 */
export const getTown = async (postalCode: number): Promise<TownResponse | null> => {
  const response = await request(getAxiosRequestConfig(Methods.GET, `towns/${postalCode}`))

  return response.success ? response.data : null
}
